import './src/assets/styles/global.css';